import {Text} from '@/components-v2/atoms/Text/Text'
import {FileUpload} from '@/components-v2/molecules/FileUpload/FileUpload'
import {Notification} from '@/components-v2/molecules/Notification/Notification'
import {Modal} from '@/components-v2/organisms/Modal/Modal'
import {uploadFileDescriptionForCSV} from '@/utils/commonTemplate'
import {Constants} from '@/utils/constants/commonConstants'
import './FileUploadWithModal.scss'
import {useFileUploadWithModal} from './useFileUploadWithModal'

/**
 * Single-file upload modal for CSV/XLSX template flows. `uploadKind` picks which upload flow
 * runs on Done - `template` (product/inventory CSV templates), `suggestedSku`, or
 * `bulkPromotion` - instead of the old pattern of matching the modal's `title` text.
 */
export const FileUploadWithModal = ({
  openUpload,
  setOpenUpload,
  title = 'Upload File',
  label = 'Upload file',
  acceptedExtensions = '.csv',
  uploadFor,
  uploadKind = 'template',
  toastMessage = 'File has successfully been uploaded and the status can be checked in Upload History',
  tertiaryButtonText,
  onClickTertiaryButton,
}) => {
  const {
    files,
    fileFeedback,
    hasError,
    uploading,
    handleFileSelect,
    handleFileDelete,
    handleFileError,
    handleDone,
    isCloseModal,
  } = useFileUploadWithModal({setOpenUpload, uploadFor, uploadKind, toastMessage})

  const showTertiaryButton = Boolean(tertiaryButtonText && onClickTertiaryButton)

  return (
    <Modal
      showModal={openUpload}
      onCloseModal={isCloseModal}
      title={title}
      type="S"
      showSecondaryButton
      showTertiaryButton={showTertiaryButton}
      secondaryButtonProps={{text: 'Cancel', variant: 'secondary', onClick: isCloseModal, disabled: uploading}}
      tertiaryButtonProps={{text: tertiaryButtonText, iconLeading: 'file_download', onClick: onClickTertiaryButton}}
      primaryButtonProps={{
        text: uploading ? 'Uploading...' : 'Done',
        onClick: handleDone,
        isLoading: uploading,
        disabled: uploading || hasError || files.length === 0,
      }}
      data-cy="upload-file-with-modal"
      className="file-upload-with-modal"
    >
      <div className="flex flex-col gap-4">
        <Text size="small">{label}</Text>
        <FileUpload
          description={uploadFileDescriptionForCSV({acceptedExtensions})}
          accept={acceptedExtensions}
          buttonLabel="Upload File"
          type="default"
          maxFiles={1}
          files={files}
          variant={uploading ? 'uploading' : 'edit'}
          feedbackType={fileFeedback?.feedbackType}
          helperText={
            fileFeedback?.helperText && (
              <Notification
                showIcon={false}
                text={fileFeedback?.helperText}
                type={
                  fileFeedback?.feedbackType === Constants.Validated ? Constants.Success : fileFeedback?.feedbackType
                }
              />
            )
          }
          onUpdate={handleFileSelect}
          onDelete={handleFileDelete}
          onFileError={handleFileError}
          data-cy="upload-file-input"
          // uploadIcon="file-format"
        />
      </div>
    </Modal>
  )
}
